<mat-card fxLayoutGap class="p-3">
  <div class="fw-semibold fs-4">{{licenseAssignmentId?'Modifica Assegnazione Licenza':'Assegna Licenza'}}</div>
  <div class="v-spacer"></div>
  <form [formGroup]="formGroup">
    <input type="text" [value]="userId" formControlName="user" hidden />
    <div class="w-100">
      <app-dea-label class="mb-2" [label]="'Licenza:'"></app-dea-label>
      <select class="form-select" formControlName="license">
        <option *ngFor="let license of licensesFullListing;" value="{{license.id}}">{{license.title}}</option>
      </select>
    </div>
    <div class="w-100">
      <app-dea-label class="mb-2" [label]="'Chiave Personale:'"></app-dea-label>
      <input formControlName="key" type="text" class="form-control dea-form-input" />
    </div>
  </form>
  <div class="m-0 p-0 mt-3 gap-2" mat-dialog-actions align="end">
    <button class="px-5 py-1" mat-stroked-button (click)="onDismiss()">Annulla</button>
    <button *ngIf="!isPosting" class="px-5 py-1" mat-flat-button color="primary" (click)="onConfirm()">
      Salva
    </button>
    <button *ngIf="isPosting" class="px-5 py-1" mat-flat-button disabled>
      <mat-icon><mat-spinner diameter="18"></mat-spinner></mat-icon> Assegnazione
    </button>
  </div>
</mat-card>